import BaseModelInstance from './base.model'
import { EliteAgencyTeam as ModelDefinition } from './model-definitions'

class EliteAgencyTeam extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default EliteAgencyTeam
